export default __webpack_public_path__ + "static/media/Arcesium.34bbc956.png";